import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { resetSession } from "../../../redux/auth";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { EmptyJobsPage } from "../../../assets/images";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import {
  getJobChecklistDataAction,
  resetError,
  resetJobCheckTotalCount,
  resetJobChecklistData,
  resetMessage,
  resetStatusCode,
  resetSuccess,
} from "../../../redux/jobs";
import { SearchIcon } from "../../../components/Icon";
import useDebounce from "../../../customHooks/useDebounce";
import JobCheckListTable from "../../../components/JobListing/JobChecklist/JobChecklistTable";
import { ChecklistItemType, GetJobCheckListPayloadType } from "../../../commonTypes/jobsType";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type AppProps = {
  token: string | null;
  success: number | null;
  fetching: boolean;
  error: string | null | undefined;
  message: string | null | undefined;
  statusCode: number | null;
  history?: any;
  jobChecklistCount: number;
  jobChecklistData: ChecklistItemType[] | [];
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetJobsList: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetJobsTotalCount: () => void;
  dispatchGetJobCheckListData: (data: GetJobCheckListPayloadType) => void;
  dispatchResetJobChecklist: () => void;
  dispathResetJobChecklistCount: () => void;
};

const JobChecklist = ({
  token,
  success,
  fetching,
  error,
  statusCode,
  history,
  message,
  jobChecklistCount,
  jobChecklistData,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetSuccess,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchGetJobCheckListData,
  dispatchResetJobChecklist,
  dispathResetJobChecklistCount,
}: AppProps) => {
  const persistSearchValue = history?.location?.state?.searchTerm;
  const [data, setData] = useState<ChecklistItemType[] | []>([]);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [searchTerm, setSearchTerm] = useState(persistSearchValue);
  const [isApiCall, setIsApiCall] = useState(false);
  const [isAddJobChecklistPresent,setIsAddJobChecklistPresent]=useMenuCheck()
  const [isEditJobChecklistPresent,setIsEditJobChecklistPresent]=useMenuCheck()

  const job_id =
    history?.location?.state?.job_id ||
    history?.location?.state?.state?.side_menu_id?.current;

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    setIsEditJobChecklistPresent("Edit Job Checklist","menu")
    setIsAddJobChecklistPresent("Add Job Checklist","menu")
    dispathResetJobChecklistCount();
    dispatchResetJobChecklist();
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetStatusCode();
    setData([]);
  }, []);

  const handleSearch = (e: any) => {
    setSearchTerm(e?.target?.value);
  };

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        jobTypeId: job_id,
        limit,
        offset,
        searchTerm,
      };

      if (jobChecklistCount) {
        if (+jobChecklistCount > offset) {
          dispatchGetJobCheckListData(finalData);
          setIsApiCall(true);
        }
      } else {
        dispatchGetJobCheckListData(finalData);
        setIsApiCall(true);
      }
    }
  }, [offset]);

  const fetchNewData = () => {
    setOffset(0);
    if (token) {
      let finalData = {
        token,
        jobTypeId: job_id,
        limit,
        offset: 0,
        searchTerm,
      };
      dispatchGetJobCheckListData(finalData);
    }
  };

  useDebounce(
    () => {
      if (isApiCall) {
        if (searchTerm) {
          if (offset > 0) {
            setOffset(0);
          } else {
            fetchNewData();
          }
        } else {
          let finalData = {
            token,
            jobTypeId: job_id,
            limit,
            offset: 0,
            searchTerm: "",
          };
          dispatchGetJobCheckListData(finalData);
        }
      }
    },
    500,
    [searchTerm]
  );

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +jobChecklistCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (jobChecklistData?.length > 0) {
          if (!fetching && offset < +jobChecklistCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (jobChecklistData?.length === 0) {
      setData(jobChecklistData);
    } else if (offset > 0 && jobChecklistData?.length > 0) {
      setData((prv: any) => [...prv, ...jobChecklistData]);
    } else {
      setData(jobChecklistData);
    }
  }, [jobChecklistData]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [jobChecklistData]);

  const handleEditJobsChecklist = (id: any) => {
    history.push({
      pathname: `/jobs/jobs-type/checklist/edit`,
      state: { job_id, id ,searchTerm : searchTerm?.trim()},
    });
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
              dispatchResetSuccess();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-4 mb-3">
        <CommonHeader title="Job Checklist" />
      </div>

      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header mb-1">
            <div className="left-header">
              <div className="heading" style={{ marginBottom: 0 }}>
                {" "}
                Job Checklist
              </div>
              <div className="sub-heading">{`Total ${
                jobChecklistCount ? jobChecklistCount : 0
              } checklist found`}</div>
            </div>

            <div className="right-header">
              <div className="col-md-7 position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchTerm}
                />
              </div>
              {isAddJobChecklistPresent ? <button
                onClick={() =>
                  history.push({
                    pathname: `/jobs/jobs-type/checklist/add`,
                    state: { job_id },
                  })
                }
                className="btn btn-primary"
              >
                + Add Job Checklist
              </button> : null}
            </div>
          </div>

          <div>
            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : data?.length > 0 ? (
              <JobCheckListTable
                history={history}
                data={data}
                isEditJobChecklistPresent={isEditJobChecklistPresent}
                handleEditJobsChecklist={handleEditJobsChecklist}
              />
            ) : (
              <div className="mt-5 p-4">
                <EmptyListPage
                  title="No Data Found!"
                  image={EmptyJobsPage}
                  imageWidth="30%"
                  showLinkButton={false}
                  showAddButton={false}
                />
              </div>
            )}
          </div>

          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </div>
      </div>
      {handleErrorModal()}
    </div>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.jobs.fetching,
  success: state.jobs.success,
  statusCode: state.jobs.statusCode,
  error: state.jobs.error,
  message: state.jobs.message,
  jobChecklistCount: state.jobs.jobChecklistCount,
  jobChecklistData: state.jobs.jobChecklistData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetSuccess()),
  dispatchResetMessage: () => dispatch(resetMessage()),
  dispatchResetError: () => dispatch(resetError()),
  dispatchResetStatusCode: () => dispatch(resetStatusCode()),
  dispatchGetJobCheckListData: (data: GetJobCheckListPayloadType) =>
    dispatch(getJobChecklistDataAction(data)),
  dispatchResetJobChecklist: () => dispatch(resetJobChecklistData()),
  dispathResetJobChecklistCount: () => dispatch(resetJobCheckTotalCount()),
});

export default connect(mapStateTopProps, mapDispatchToProps)(JobChecklist);
